{
"aboutATB": "About Attribute Toolbox",
"aboutHeader": "About...",
"atbVersion": "Backend Version:",
"frontendVersion": "Frontend Version:",
"experianProtectedEnabled": "Experian Protected Creation Enabled?",
"deploymentEnabled": "Deployment Enabled?",
"committingCodeEnabled": "Committing Code Enabled?",
"close": "Close"
}